import React from 'react';
import AddressComponent from '../../../components/Address';
import DateMoveComponent from '../../../components/dateMove';
import { CHOOSE_ADD } from '../../../components/Address/addressUtils/addressConstants';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';

export const renderHeading = heading => <SectionHeading heading1={heading} />;

export const renderAddressComponent = (
  list,
  values,
  PreviousAddressTitle,
  heading,
  currentOfficerNumber
) =>
  list
    ? list.map((v, index) => (
        <div key={`wrapper${v}`}>
          {' '}
          {renderHeading(`${index + 1}. ${heading}`)}
          {getAddressComponent(values, PreviousAddressTitle, v, currentOfficerNumber)}{' '}
          {getDateMoveComponent(values, v, currentOfficerNumber, index)}
        </div>
      ))
    : '';

const getAddressComponent = (values, PreviousAddressTitle, type, currentOfficerNumber) => (
  <AddressComponent
    key={`address${type}`}
    type={type}
    formValues={values}
    isPostCodeOnly={false}
    chooseAddressHeading={PreviousAddressTitle}
    currentIndex={currentOfficerNumber}
  />
);
const getDateMoveComponent = (values, type, currentIndex, index) =>
  values[type] &&
  (values[type][CHOOSE_ADD] || values[type].givenAddress) && (
    <DateMoveComponent
      key={`date${type}`}
      type={type}
      formValues={values}
      currentIndex={currentIndex}
      dateIndex={index + 1}
    />
  );
